module.exports = __webpack_public_path__ + "img/marca.d671aa82.png";